<template>
  <div style="padding-left: 20px">
    <b-input-group v-if="!readonly">
      <b-form-select class="text-center" id="ph_schedule" v-model="s.day" :options="codes.WSF_SCHEDULE_i18n['EN']" :disabled="schedule.length >= 10"></b-form-select>
      <b-form-input class="text-center" type="text" v-model="s.time" :disabled="schedule.length >= 10"></b-form-input>
      <b-input-group-append>
        <b-button class="btn-addition" variant="primary" @click="add_schedule()" :disabled="schedule.length >= 10">Add</b-button>
      </b-input-group-append>
    </b-input-group>
    <hr v-if="!readonly">
    <small v-if="!(hide_text === true)">Can set schedule Max 10</small>
    <b-list-group>
      <b-list-group-item v-for="(item, index) in schedule" :key="index" ref="_cron">
        {{item.name}} @ {{item.time}} {{item.index}}
        <span v-if="!readonly" @click="remove_sch(index)" style="cursor: pointer;">
          <i class="fa fa-times"></i>
        </span>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
